var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWohnungsvermarktung(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 62.5 65.3",
    style: {
      enableBackground: "new 0 0 62.5 65.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.3,5.4C57.8,5.1,57,4.9,56,5.5L40.5,15.9H16.7C8.3,15.9,2.5,21,2.5,28.3c0,6.3,4.2,11.1,10.6,12.4l0.3,0 l0,0.3c0.1,0.5,2.3,14.6,2.3,14.6c0,1.9,1.5,3.3,3.3,3.3l5.5,0c1.8,0,3.3-1.5,3.3-3.3l-2.4-14.9h15.1l0.1,0.1l15.2,10.1 c0.9,0.6,1.9,0.7,2.7,0.3c0.9-0.5,1.5-1.6,1.5-2.8v-40C60,7.1,59.3,5.9,58.3,5.4z M22.7,56h-1.8c-1.2,0-2.2-1-2.2-2.2l-2.2-13.1l6,0 l2.1,13.1C24.6,55.1,23.8,56,22.7,56z M33.5,37.8H16.7c-3.4,0-11.3-0.9-11.3-9.5c0-2.8,0.8-5,2.5-6.6c2.8-2.7,7.1-2.9,8.8-2.8 l16.8,0V37.8z M40.7,37.8h-4.4v-19h4.4V37.8z M57.1,48.5l-13.5-9.1V17.2l13.5-9.1V48.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWohnungsvermarktung);
export default __webpack_public_path__ + "static/media/Wohnungsvermarktung.87956bc81a3adacf87c1052d362a34d5.svg";
export { ForwardRef as ReactComponent };